import { useState, useEffect, useCallback } from 'react';
import { createConnectOnboarding, getConnectStatus } from '../services/stripeService';

// Shared Stripe Connect status/onboarding logic for verified businesses —
// used by both ProfilePage and BusinessDashboard so they don't run two
// independent, driftable polling implementations.
export function useOrganizerPayouts(user, { onConnected } = {}) {
  const [connectStatus,  setConnectStatus]  = useState(null);
  const [connectLoading, setConnectLoading] = useState(false);
  const [connectError,   setConnectError]   = useState('');

  const loadConnectStatus = useCallback(async () => {
    try {
      const status = await getConnectStatus();
      setConnectStatus(status);
    } catch {
      // silent — user may not have a Connect account yet
      setConnectStatus({ connected: false, chargesEnabled: false });
    }
  }, []);

  useEffect(() => {
    if (!user) return;
    loadConnectStatus();
  }, [user, loadConnectStatus]);

  // Handle returning from Stripe Connect onboarding
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('connect') === 'success') {
      loadConnectStatus();
      onConnected?.();
      window.history.replaceState({}, '', window.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadConnectStatus]);

  async function handleConnectStripe() {
    setConnectLoading(true);
    setConnectError('');
    try {
      const url = await createConnectOnboarding();
      window.location.href = url;
    } catch (err) {
      setConnectError(err.message);
      setConnectLoading(false);
    }
  }

  return { connectStatus, connectLoading, connectError, handleConnectStripe };
}
